/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import { api } from '@seaoil/component-lib';

import AsyncAutoComplete from './AsyncAutoComplete';
import { VIEW_NAME } from '../../api/DataWarehouse';

const { mySEAOIL } = api;

function SupplierPaygroup({
  style,
  placeholder,
  disabled,
  onInputSelect,
}) {
  const [paygroups, setPaygroups] = useState([]);
  const [loading, isLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const loadPaygroups = async () => {
    try {
      isLoading(true);
      const pgroups = await mySEAOIL.datawarehouse.view({
        viewName: VIEW_NAME.SUPPLIER_PAYGROUP,
        schema: 'source',
        filters: [],
        orderBy: [
          {
            field: 'pay_group_lookup_code',
            value: 'ASC',
          },
        ],
      }).send();

      setPaygroups(pgroups.records);
    } catch (e) {
      message.error('Unable to load paygroups.');
    } finally {
      isLoading(false);
    }
  };

  useEffect(() => {
    loadPaygroups();
  }, []);

  useEffect(() => {
    if (!Array.isArray(paygroups)) {
      return;
    }
    setOptions(paygroups.map(({
      pay_group_lookup_code,
    }) => ({
      value: pay_group_lookup_code,
      label: pay_group_lookup_code,
    })));
  }, [paygroups]);

  return (
    <AsyncAutoComplete
      style={style}
      placeholder={placeholder}
      loading={loading}
      disabled={disabled}
      options={options}
      onInputSelect={(lookup_code) => {
        if (paygroups) {
          const selectedPaygroup = paygroups
            .find((paygroup) => {
              const { pay_group_lookup_code } = paygroup;
              return pay_group_lookup_code === lookup_code;
            });

          onInputSelect(selectedPaygroup);
        }
      }}
    />
  );
}

export default SupplierPaygroup;
